import Model, { attr } from '@ember-data/model';

export default class UploadModel extends Model {
  @attr('string') url!: string;
  @attr('string') filename!: string;
  @attr('string') contentType!: string;
  @attr('string') cdnUrl!: string;
  @attr('object') fields!: Record<string, string>;
  @attr('string') bucket!: string;
  @attr('string') key!: string;
  @attr('string') checksumAlgorithm?: string;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    upload: UploadModel;
  }
}
